var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 125"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.399 56.801c0 15.904 12.896 28.8 28.8 28.8s28.8-12.896 28.8-28.8c0-15.883-12.864-28.765-28.743-28.796v15.198L28.656 21.6 50.256 0v13.605c23.828.031 43.143 19.356 43.143 43.195-.001 23.857-19.343 43.2-43.2 43.2S7 80.657 7 56.801h14.399z"
  })));
}
export default SvgRotate;